// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  encyptionKey: "kunotori@123",
  // API_BASE_URL: "http://localhost:3000/v1/api/",
  API_BASE_URL: "https://dev-api.ktoexchange.com/v1/api/",
  CHART_API_BASE_URL: "https://dev-api.ktoexchange.com/charting_engine/v1/api",
  CANDLE_CHART: "ON", // ON, OFF
  SUMSUB_VERIFICATION_BYPASS: "ON", // ON, OFF
  SOCKET_URL: "ws://localhost:3000/",
  s3Base: "https://dev-kto-media.s3.eu-west-2.amazonaws.com/",
  platformFee: 0.01,
  requestId: "1b1cafca-89cf-11ee-b9d1-0242ac120002", // Used to distinct email navigation and in-app flow
  firebase: {
    apiKey: "AIzaSyCCashSr9JfZwyf86mv1zronCAC--cBrNE",
    authDomain: "kto-dev-31cc6.firebaseapp.com",
    projectId: "kto-dev-31cc6",
    storageBucket: "kto-dev-31cc6.appspot.com",
    messagingSenderId: "674156278201",
    appId: "1:674156278201:web:a7d6c19393f3f4a7a30668",
    measurementId: "G-MMVT7JEHPT",
    vapidKey: "BG_WPeeNwcY5I0mqVd2KBhdQhTS0gXp_ALU4LxX2RFSxjBel3YfV04WSDdlAtj82vmJxeWPg6mThoxqKzzseMRM"
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
